import {
  PaywallFeature,
  useHasPaywallFeatureStateResolved,
  useIsPaywallUnlocked
} from '@canvas/paywall';

/**
 * Returns whether the current site has resolved entitlement to use Database Rovo.
 *
 * Product experiments and feature flags remain owned by their individual UI
 * surfaces and must be composed with this result at the render boundary.
 */
export const useIsDatabaseRovoAvailable = (): boolean => {
  const hasPaywallFeatureStateResolved = useHasPaywallFeatureStateResolved();
  const isAiTeammatePaywallUnlocked = useIsPaywallUnlocked(PaywallFeature.AI_TEAMMATE);

  return hasPaywallFeatureStateResolved && isAiTeammatePaywallUnlocked;
};
